import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventTicketState }    from 'Redux/Slices/EventTicket/EventTicketSlice';
import { EventTicket }          from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findEventTicketRequest = (state: Draft<IEventTicketState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findEventTicketSuccess = (state: Draft<IEventTicketState>, { type, payload }: PayloadAction<{
  eventTicket: EventTicket
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, [payload.eventTicket.id]: payload.eventTicket };
};

export const findEventTicketFailure = (state: Draft<IEventTicketState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
